// components
import WindowedList from './WindowedList';

export default WindowedList;
